import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-brand-icon',
  standalone: true,
  templateUrl: './brand-icon.component.html'
})
export class BrandIconComponent {
  @Input() width: number | string = 26;
  @Input() height: number | string = 21;
}
